export default {"src":"/_next/static/media/download.2068b2a7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};